<template>
  <TheTopBar :controls="controls" with-fullscreen-button>
    <template #pointer-events-disabled-relative-slot>
      <TopBarLabel v-if="!!labelText" align="left">
        {{ labelText }}
      </TopBarLabel>
    </template>
  </TheTopBar>
</template>

<script>
import TheTopBar from '@/components/Gadgets/TheTopBar'
import TopBarControlsSuite from '@/classes/TopBarControls/TopBarControlsSuite'
import TopBarLabel from '@/components/Gadgets/TheTopBar/snippets/TopBarLabel'

export default {
  name: 'GalleryTopBarControls',
  components: {
    TheTopBar,
    TopBarLabel,
  },
  props: {
    labelText: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    controls() {
      return new TopBarControlsSuite({})
    },
  },
}
</script>
